export default [
  {
    name: 'Dashboard',
    icon: 'ti-panel',
    children: [
 
      {
        name: 'Transactions',
        path: '/home/transactions'
      }
    ]

  },
  
  {
    name: 'Classrooms',
    icon: 'ti-blackboard',
    children: [
      {
        name: 'List',
        path: '/classroom/list'
      },
      {
        name: 'Create',
        path: '/classroom/create'
      },
      {
        name: 'Tutors',
        path: '/classroom/tutors'
      },
      {
        name: 'Venues',
        path: '/classroom/venues'
      },
      {
        name: 'Invoice',
        path: '/classroom/invoices'
      },
     /* {
        name: 'Manage',
        path: '/classroom/manage'
      }*/
    ]
  },
  {
    name: 'Products',
    icon: 'ti-agenda',
    children: [
      {
        name: 'List',
        path: '/product/list'
      }/* ,
      {
        name: 'Create',
        path: '/product/create'
      } */
    ]
  },
  {
    name: 'Orders',
    icon: 'ti-receipt',
    children: [
      {
        name: 'List',
        path: '/order/list'
      },
      {
        name: 'Create',
        path: '/order/create'
      }
    ]
  },
  {
    name: 'Customers',
    icon: 'ti-user',
    children: [
      {
        name: 'List',
        path: '/customer/list'
      },
      {
        name: 'Create',
        path: '/customer/create'
      }
    ]
  },
  {
    name: 'Certificates',
    icon: 'ti-medall-alt',
    children: [
      {
        name: 'List',
        path: '/certificates/list'
      },
      {
        name: 'Print',
        path: '/certificates/print'
      }
    ]
  },
  {
    name: 'Reports',
    icon: 'ti-book',
    children: [
      {
        name: 'Balance Payments',
        path: '/reports/balances'
      },
     
      {
        name: 'Sales',
        path: '/reports/sales'
      },
      {
        name: 'Sales Transactions',
        path: '/reports/salestrans'
      },
     
      {
        name: 'Certs Sent',
        path: '/reports/certsent'
      },
      
     
      {
        name: 'Partner Enrols',
        path: '/reports/partners'
      },
      
     
      {
        name: 'Flexible Classroom',
        path: '/reports/flexibles'
      }
      ,   
      {
        name: 'Frequently Bought',
        path: '/reports/frequently'
      }
      ,
      
      {
        name: 'Advanced Purchases',
        path: '/reports/advanced'
      }
    ]
  },
  {
    name: 'Promotions',
    icon: 'ti-gift',
    children: [
      {
        name: 'List',
        path: '/promotions/list'
      }
    ]
  },
  {
    name: 'Mailchimp',
    icon: 'ti-email',
    children: [
      {
        name: 'Members',
        path: '/mailchimp/list'
      },
      {
        name: 'Campaigns',
        path: '/mailchimp/campaigns/'
      }
      ,
      {
        name: 'Automations',
        path: '/mailchimp/automations/'
      }
      ,
      {
        name: 'Stores',
        path: '/mailchimp/ecommerce/'
      }
    ]
  },
  
 /*  {
    name: 'Finance',
    icon: 'ti-email',
    children: [
      {
        name: 'Sales Figures',
        path: '/finance/sales'
      }
    ]
  } */

]



// WEBPACK FOOTER //
// ./src/sidebarLinks.js